import { X } from "lucide-react";
import type { CSSProperties, JSX, ReactNode } from "react";
import { cx } from "../cx";

export interface TagProps {
  /** Mono type (default true) — relations, invariant names, versions. */
  mono?: boolean | undefined;
  /** Show a remove affordance. */
  onRemove?: (() => void) | undefined;
  className?: string | undefined;
  style?: CSSProperties | undefined;
  children?: ReactNode | undefined;
}

/**
 * Square-cornered metadata tag. Ported from
 * design/tarski-kit/components/display/Tag.jsx.
 */
export function Tag({ mono = true, onRemove, className, style, children }: TagProps): JSX.Element {
  return (
    <span className={cx("tk-tag", !mono && "tk-tag--sans", className)} style={style}>
      {children}
      {onRemove === undefined ? null : (
        <button type="button" className="tk-tag__remove" aria-label="Remove" onClick={onRemove}>
          <X size={12} aria-hidden="true" />
        </button>
      )}
    </span>
  );
}
